import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreHref,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 border-b border-background-200 pb-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl font-body text-sm leading-6 text-foreground-600">{description}</p>
        )}
      </div>
      {moreHref && (
        <Link
          to={moreHref}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}